function Error () {
    return(
        <>
            Error
        </>
    )
}

export default Error;